import { render } from "./ClassRoomStudentDetail.vue?vue&type=template&id=52aaed0b&scoped=true&ts=true"
import script from "./ClassRoomStudentDetail.vue?vue&type=script&lang=ts"
export * from "./ClassRoomStudentDetail.vue?vue&type=script&lang=ts"

import "./ClassRoomStudentDetail.vue?vue&type=style&index=0&id=52aaed0b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aaed0b"]])

export default __exports__